import http from './ApiConfig';
import { Service } from './Service';

export interface CompartilhamentoGerado {
  id: number;
  url: string;
  expiraEm: string;
}

export interface CompartilhamentoItem {
  id: number;
  pacienteId: number;
  finalidade?: string | null;
  criadoPor?: string | null;
  criadoEm: string;
  expiraEm: string;
  revogadoEm?: string | null;
  acessosCount: number;
  ultimoAcessoEm?: string | null;
  ativo: boolean;
}

// C8 — Compartilhamento de prontuário via link expirável/revogável.
// Backend: api/prontuario/compartilhamento (staff, CompartilharProntuarioGerenciar);
// resumo público em api/prontuario-compartilhado?token= (o token JWT do link É a credencial).
export class CompartilhamentoService extends Service {
  constructor() {
    super('api/prontuario/compartilhamento');
  }

  // Gera o link. A URL com o token aparece SÓ nesta resposta (apenas o hash é persistido).
  public Gerar(pacienteId: number, finalidade?: string, validadeHoras?: number) {
    return http.post(
      `${this._nomeControle}/gerar`,
      {
        pacienteId,
        finalidade: finalidade || null,
        validadeHoras: validadeHoras || null,
      },
      this.GetHeader(),
    );
  }

  // Revoga o link imediatamente (morre antes da expiração).
  public Revogar(id: number) {
    return http.post(`${this._nomeControle}/${id}/revogar`, {}, this.GetHeader());
  }

  // Envio opcional por WhatsApp (default: telefone do paciente). Atenção: o backend
  // ROTACIONA o token no envio — o link copiado antes deixa de valer.
  public EnviarWhatsApp(id: number, telefoneDestino?: string) {
    return http.post(
      `${this._nomeControle}/${id}/enviar-whatsapp`,
      { telefoneDestino: telefoneDestino || null },
      this.GetHeader(),
    );
  }

  // Lista os compartilhamentos do paciente (ativos, revogados e expirados).
  public ListarPorPaciente(pacienteId: number) {
    return http.get(`${this._nomeControle}/paciente/${pacienteId}`, this.GetHeader());
  }

  // Público (sem login): resumo do prontuário gated pelo token do link.
  public ObterPublico(token: string) {
    return http.get('api/prontuario-compartilhado', {
      ...this.GetHeader(),
      params: { token },
    });
  }
}

export default CompartilhamentoService;
